export enum VALIDATION_RULES {
  REQUIRED = 'required',
  MINLENGTH = 'minlength',
  MAXLENGTH = 'maxlength',
  PATTERN = 'pattern',
}
